module.exports = __webpack_public_path__ + "assets/img/news-nodata.1eb7937b.png";